import React, { useEffect, useState } from "react";
import { DetalleSolicitudApi } from "../api/DetalleSolicitudApi";
import { NotificationManager } from "react-notifications";
import Swal from "sweetalert2";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { LAB_PRODUCCION_ESTADOS_DRC } from "../../../../../../../utility/constants";
import moment from "moment";
import { calcularPromediosDRC } from "../helpers/datosDRC";

export const useAnalisisDRC = (analisisId, setTipoSolicitud, regresar) => {
    const {
        getDetalleAnalisis,
        actualizarAnalisisDRC,
        guardarAnalisisDRC,
        cargando,
    } = DetalleSolicitudApi();

    const [analisisDetalle, setAnalisisDetalle] = useState({});

    const [fechaAnalisis, setFechaAnalisis] = useState(moment());
    const [horaAnalisis, setHoraAnalisis] = useState(moment().format("HH:mm"));
    const [observaciones, setObservaciones] = useState("");

    const GetAnalisisDetalle = async () => {
        try {
            if (!analisisId) return;
            const data = await getDetalleAnalisis(analisisId);

            if (data) {
                setAnalisisDetalle(data);
                if (!data.analisis) return;
                if (data.analisis.fecha_analisis)
                    setFechaAnalisis(moment(data.analisis.fecha_analisis));
                if (data.analisis.hora_analisis)
                    setHoraAnalisis(data.analisis.hora_analisis);
                if (data.analisis.observaciones)
                    setObservaciones(data.analisis.observaciones);

                if (data.detalle) setTipoSolicitud(data.detalle.tipo);
            }
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el detalle del análisis",
            );
            Swal.fire({
                title: "Error",
                text: errorMsg,
                type: "error",
            });
            setAnalisisDetalle({});
        }
    };

    const GuardarAnalisisDRC = async (
        datosDRC,
        contaminantes,
        skipMessage = false,
    ) => {
        try {
            if (!horaAnalisis || !fechaAnalisis) {
                NotificationManager.error(
                    "Debe ingresar fecha y hora del análisis",
                    "Error",
                    3000,
                );
                return;
            }

            // filtrar contaminantes con datos incompletos
            const contaminantesFiltrados = contaminantes.filter(
                (contaminante) =>
                    contaminante.material_contaminante &&
                    contaminante.nivel_contaminacion,
            );

            // Lógica para guardar la gestión de almacén
            await guardarAnalisisDRC(analisisId, {
                datos_drc: datosDRC,
                contaminantes: contaminantesFiltrados,
                fecha_analisis: fechaAnalisis
                    ? moment(fechaAnalisis).format("YYYY-MM-DD")
                    : null,
                hora_analisis: horaAnalisis,
                observaciones,
            });

            if (!skipMessage) {
                NotificationManager.success(
                    "Análisis DRC guardado con éxito",
                    "Éxito",
                    3000,
                );
            }

            GetAnalisisDetalle();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al guardar el análisis DRC",
            );
            Swal.fire({
                title: "Error",
                text: errorMsg,
                type: "error",
            });
        }
    };

    const AsignarDRC = async (datosDRC, contaminantes) => {
        try {
            if (datosDRC.length === 0) {
                NotificationManager.error(
                    "No hay datos de DRC para asignar",
                    "Error",
                    3000,
                );
                return;
            }

            // guardar antes
            await GuardarAnalisisDRC(datosDRC, contaminantes, true);

            const { drc_promedio } = calcularPromediosDRC(datosDRC);

            // enviar a validación
            const body = {
                drc_final: drc_promedio,
                estado: LAB_PRODUCCION_ESTADOS_DRC.PENDIENTE_VALIDAR_DRC,
            };

            await actualizarAnalisisDRC(analisisId, body);

            NotificationManager.success(
                "Análisis DRC enviado a validación con éxito",
                "Éxito",
                3000,
            );

            regresar();
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al enviar análisis DRC a validación",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const ValidarDRC = async () => {
        try {
            const body = {
                estado: LAB_PRODUCCION_ESTADOS_DRC.DRC_VALIDO,
                fecha_validacion_drc: moment().format("YYYY-MM-DD"),
            };

            await actualizarAnalisisDRC(analisisId, body);

            NotificationManager.success(
                "Análisis DRC validado con éxito",
                "Éxito",
                3000,
            );

            regresar();
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al validar análisis DRC",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const RechazarDRC = async () => {
        try {
            const body = {
                estado: LAB_PRODUCCION_ESTADOS_DRC.DRC_RECHAZADO,
            };

            await actualizarAnalisisDRC(analisisId, body);

            NotificationManager.success(
                "Análisis DRC rechazado con éxito",
                "Éxito",
                3000,
            );

            regresar();
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al rechazar análisis DRC",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        if (analisisId) GetAnalisisDetalle();
    }, [analisisId]);

    return {
        analisisDetalle,

        fechaAnalisis,
        setFechaAnalisis,
        horaAnalisis,
        setHoraAnalisis,
        observaciones,
        setObservaciones,

        GuardarAnalisisDRC,
        AsignarDRC,
        ValidarDRC,
        RechazarDRC,
        cargando,
    };
};
